import { StatusCodesHelper } from "../../models/StatusCodesHelper";
import { StatusCodes } from "http-status-codes";
import { useGetDiscogsIdentity } from "./useGetDiscogsIdentity";
import { useGetDiscogsRequestToken } from "./useGetDiscogsRequestToken";
import { useOpenWindow } from "../openWindow";

export const useCheckDiscogsAccess = (
  setAlertMessage: (message: string) => void,
  setIsAlertOpen: (isOpen: boolean) => void,
  setIsLoading: (isLoading: boolean) => void,
  onSuccess: () => void
) => {
  const { openInSameTab } = useOpenWindow();
  const getDiscogsIdentity = useGetDiscogsIdentity();
  const getDiscogsRequestToken = useGetDiscogsRequestToken();
  const getDiscogsToken = async () => {
    const { body, status } = await getDiscogsRequestToken();
    if (StatusCodesHelper.isSuccessful(status)) {
      localStorage.setItem("discogs_temp", body.secret);
      localStorage.setItem("discogs_level", body.authLevel);
      openInSameTab(body.authorizeUrl);
    } else {
      setAlertMessage(body.message);
      setIsAlertOpen(true);
    }
    setIsLoading(false);
  };
  const checkDiscogsAccess = async () => {
    const { body, status } = await getDiscogsIdentity();
    if (StatusCodesHelper.isSuccessful(status)) {
      setIsLoading(false);
      onSuccess();
    } else if (status == StatusCodes.NOT_FOUND) {
      await getDiscogsToken();
    } else {
      setAlertMessage(body.message);
      setIsAlertOpen(true);
      setIsLoading(false);
    }
  };
  return { checkDiscogsAccess, getDiscogsToken };
};
